import { createAction, props } from '@ngrx/store';

import {
    IResultComprasDiasSem,
    IResultComprasMes,
    IResultComprasTickets,
} from '../../private/shared/models/historico-ventas';


/**
 * * Obtiene configuraciones del mes para ventas y tickets
 */
export const ventasMes = createAction(
    '[VentasMes] Get Sales tickets'
);

export const successVentasMes = createAction(
    '[VentasMes] Get Sales tickets Success',
    props<IResultComprasMes>()
);

export const errroVentasMes = createAction(
    '[VentasMes] Get Sales tickets Error',
    props<{ payload: Error }>()
);

/**
 * * Obtiene las ventas y sus montos por mes seleccionado
 */
export const ventasMesSeleccion = createAction(
    '[VentasMesSeleccion] Get Sales amount',
    props<{ FechaMes: string; MesActual: boolean; IsTicket: boolean; }>()
);

export const successVentasMesSeleccion = createAction(
    '[VentasMesSeleccion] Get Sales amount Success',
    props<IResultComprasDiasSem>()
);

export const reloadVentasMesSeleccion = createAction(
    '[VentasMesSeleccion] Reload Sales amount Success',
    props<IResultComprasDiasSem>()
);

export const errroVentasMesSeleccion = createAction(
    '[VentasMesSeleccion] Get Sales amount Error',
    props<{ payload: Error }>()
);

/**
 * * Obtiene los tickets de preventa por mes seleccionado
 */
export const ticketsMesSeleccion = createAction(
    '[TicketsMesSeleccion] Get tickets presale',
    props<{ InicioMes: string; IsTicketPreventa: boolean; MesActual: boolean; }>()
);

export const successTicketsMesSeleccion = createAction(
    '[TicketsMesSeleccion] Get tickets presale Success',
    props<IResultComprasTickets>()
);

export const reloadTicketsMesSeleccion = createAction(
    '[TicketsMesSeleccion] Reload tickets presale Success',
    props<IResultComprasTickets>()
);

export const errroTicketsMesSeleccion = createAction(
    '[TicketsMesSeleccion] Get tickets presale Error',
    props<{ payload: Error }>()
);


/**
 * * Limpia el estado de acumulado de ventas y tickets
 */
export const clearVentasMes = createAction(
    '[ClearVentasMes] Clear Sales and tickets'
);
